module.exports = __webpack_public_path__ + "img/ki.bf67582.svg";